<template>
  <div v-if="track.expanded" class="track-detail content">
    <figure class="firstImage">
      <img v-bind:src="'/static/img/'+firstImage.src" style="min-height: 300px"/>
      <figcaption class="is-size-7">{{firstImage.caption}}</figcaption>
    </figure>
    <p v-html="track.paragraph"></p>
    <figure v-for="image in moreImages">
      <img v-lazy="'/static/img/'+image.src" style="min-height: 200px" />
      <figcaption class="is-size-7">{{image.caption}}</figcaption>
    </figure>
  </div>
</template>

<script>
import Vue from 'vue'

export default {
  name: 'track-list-detail',
  props: ['track'],
  computed: {
    firstImage: function () {
      if (this.track.images.length > 0) {
        return this.track.images[0]
      } else {
        return {
          src: '',
          caption: ''
        }
      }
    },
    moreImages: function () {
      if (this.track.images.length > 0) {
        return this.track.images.slice(1)
      } else {
        return []
      }
    }
  },
  methods: {
    toggle: function () {
      Vue.set(this.track, 'expanded', false)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#track1 figure {
  margin: 0;
  height: 0;
}
#track1 img {
  min-height: 0 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/ListenPage/TrackListDetail.vue?4ea1e4d7